// Cabin Crew Training - Kabin Memurluğu İçerikleri (BÖLÜM 2)
// Ünite 9-20 = 12 Ünite x 5 Ders = 60 Ders

export const CABIN_CREW_CONTENTS = {
  // ==================== BÖLÜM 2: KABİN MEMURLUĞU ====================
  
  // ÜNİTE 9: Uçak Terminolojisi
  '9-1': {
    type: 'flashcard',
    title: 'Uçak Parçaları',
    cards: [
      { front: 'Fuselage', back: 'Gövde' },
      { front: 'Wing', back: 'Kanat' },
      { front: 'Tail', back: 'Kuyruk' },
      { front: 'Cockpit', back: 'Kokpit / Pilot kabini' },
      { front: 'Engine', back: 'Motor' },
      { front: 'Landing gear', back: 'İniş takımları' },
      { front: 'Nose', back: 'Burun' },
      { front: 'Winglet', back: 'Kanat uçları' },
      { front: 'Stabilizer', back: 'Dengeleyici' },
      { front: 'Flaps', back: 'Flep (kanat kanatları)' },
      { front: 'Rudder', back: 'Dümen' },
      { front: 'Cargo hold', back: 'Kargo bölümü' },
    ]
  },
  '9-2': {
    type: 'flashcard',
    title: 'Kabin Bölümleri',
    cards: [
      { front: 'Cabin', back: 'Kabin / Yolcu bölümü' },
      { front: 'Galley', back: 'Mutfak / Servis alanı' },
      { front: 'Lavatory', back: 'Tuvalet' },
      { front: 'First class', back: 'Birinci sınıf' },
      { front: 'Business class', back: 'İş sınıfı' },
      { front: 'Economy class', back: 'Ekonomi sınıfı' },
      { front: 'Overhead bin', back: 'Üst bagaj gözü' },
      { front: 'Aisle', back: 'Koridor' },
      { front: 'Bulkhead', back: 'Bölüm duvarı' },
      { front: 'Jump seat', back: 'Kabin görevlisi koltuğu' },
      { front: 'Emergency exit', back: 'Acil çıkış' },
      { front: 'Crew rest area', back: 'Ekip dinlenme alanı' },
    ]
  },
  '9-3': {
    type: 'flashcard',
    title: 'Koltuk & Sıra Numaraları',
    cards: [
      { front: 'Seat', back: 'Koltuk' },
      { front: 'Row', back: 'Sıra' },
      { front: 'Window seat', back: 'Pencere koltuğu' },
      { front: 'Aisle seat', back: 'Koridor koltuğu' },
      { front: 'Middle seat', back: 'Orta koltuk' },
      { front: 'Seat number', back: 'Koltuk numarası' },
      { front: 'Row 15, seat A', back: 'Sıra 15, A koltuğu' },
      { front: 'Exit row', back: 'Acil çıkış sırası' },
      { front: 'Seat pocket', back: 'Koltuk cebi' },
      { front: 'Armrest', back: 'Kol dayanma yeri' },
      { front: 'Recline button', back: 'Yaslanma düğmesi' },
      { front: 'Tray table', back: 'Masa tableti' },
    ]
  },
  '9-4': {
    type: 'flashcard',
    title: 'Acil Çıkışlar',
    cards: [
      { front: 'Emergency exit', back: 'Acil çıkış' },
      { front: 'Exit door', back: 'Çıkış kapısı' },
      { front: 'Overwing exit', back: 'Kanat üstü çıkış' },
      { front: 'Floor-level exit', back: 'Zemin seviyesi çıkış' },
      { front: 'Emergency slide', back: 'Acil tahliye kaydırağı' },
      { front: 'Escape rope', back: 'Kaçış halatları' },
      { front: 'Exit row passenger', back: 'Acil çıkış sırası yolcusu' },
      { front: 'Evacuation', back: 'Tahliye' },
      { front: 'Brace position', back: 'Koruma pozisyonu' },
      { front: 'Exit light', back: 'Çıkış ışığı' },
    ]
  },
  '9-5': {
    type: 'quiz',
    title: 'Terminoloji Quiz',
    questions: [
      { question: '"Galley" ne demek?', options: ['Tuvalet', 'Kabin', 'Mutfak/Servis alanı', 'Kargo'], correct: 2 },
      { question: '"Aisle seat" ne demek?', options: ['Pencere koltuğu', 'Koridor koltuğu', 'Orta koltuk', 'Ön koltuk'], correct: 1 },
      { question: '"Overhead bin" nedir?', options: ['Koltuk cebi', 'Üst bagaj gözü', 'Tuvalet', 'Mutfak'], correct: 1 },
      { question: '"Landing gear" ne demek?', options: ['Kanat', 'İniş takımları', 'Motor', 'Kuyruk'], correct: 1 },
      { question: '"Lavatory" ne demek?', options: ['Mutfak', 'Kabin', 'Tuvalet', 'Kokpit'], correct: 2 },
      { question: '"Bulkhead" ne demek?', options: ['Bölüm duvarı', 'Pencere', 'Kapı', 'Koltuk'], correct: 0 },
    ]
  },

  // ÜNİTE 10: Kabin Ekipmanları
  '10-1': {
    type: 'flashcard',
    title: 'Güvenlik Ekipmanları',
    cards: [
      { front: 'Life jacket / Life vest', back: 'Can yeleği' },
      { front: 'Oxygen mask', back: 'Oksijen maskesi' },
      { front: 'Fire extinguisher', back: 'Yangın söndürücü' },
      { front: 'Smoke hood', back: 'Duman maskesi' },
      { front: 'Flashlight', back: 'El feneri' },
      { front: 'Megaphone', back: 'Megafon' },
      { front: 'Safety card', back: 'Güvenlik kartı' },
      { front: 'Seat belt', back: 'Emniyet kemeri' },
      { front: 'Emergency locator transmitter', back: 'Acil konum vericisi' },
      { front: 'Fire axe', back: 'Yangın baltası' },
      { front: 'Protective breathing equipment (PBE)', back: 'Koruyucu solunum cihazı' },
    ]
  },
  '10-2': {
    type: 'flashcard',
    title: 'Servis Ekipmanları',
    cards: [
      { front: 'Trolley / Cart', back: 'Servis arabası' },
      { front: 'Coffee pot', back: 'Kahve cezvesi/pot' },
      { front: 'Ice bucket', back: 'Buz kovası' },
      { front: 'Tray', back: 'Tepsi' },
      { front: 'Napkin', back: 'Peçete' },
      { front: 'Cutlery', back: 'Çatal bıçak takımı' },
      { front: 'Cup', back: 'Bardak (fincan)' },
      { front: 'Glass', back: 'Bardak (cam)' },
      { front: 'Blanket', back: 'Battaniye' },
      { front: 'Pillow', back: 'Yastık' },
      { front: 'Headphones', back: 'Kulaklık' },
      { front: 'Amenity kit', back: 'Yolcu paketi' },
    ]
  },
  '10-3': {
    type: 'flashcard',
    title: 'İlk Yardım Çantası',
    cards: [
      { front: 'First aid kit', back: 'İlk yardım çantası' },
      { front: 'Bandage', back: 'Bandaj' },
      { front: 'Plaster / Band-aid', back: 'Yara bandı' },
      { front: 'Antiseptic', back: 'Antiseptik' },
      { front: 'Painkillers', back: 'Ağrı kesici' },
      { front: 'Thermometer', back: 'Termometre' },
      { front: 'Scissors', back: 'Makas' },
      { front: 'Gloves', back: 'Eldiven' },
      { front: 'CPR mask', back: 'CPR maskesi' },
      { front: 'Defibrillator (AED)', back: 'Defibrilatör' },
      { front: 'Medical oxygen', back: 'Tıbbi oksijen' },
      { front: 'Emergency medical kit', back: 'Acil tıbbi kit' },
    ]
  },
  '10-4': {
    type: 'video',
    title: 'Ekipman Kullanımı',
    description: 'Güvenlik ekipmanlarının doğru kullanımını izleyin.',
    topics: [
      'Can yeleği giyme',
      'Oksijen maskesi takılması',
      'Yangın söndürücü kullanımı',
      'Defibrilatör kullanımı'
    ]
  },
  '10-5': {
    type: 'quiz',
    title: 'Ekipman Quiz',
    questions: [
      { question: '"Life vest" ne demek?', options: ['Yelek', 'Can yeleği', 'Mont', 'Gömlek'], correct: 1 },
      { question: '"Fire extinguisher" ne demek?', options: ['Yangın algılayıcı', 'Duman dedektörü', 'Yangın söndürücü', 'Yangın alarmı'], correct: 2 },
      { question: '"Trolley" ne demek?', options: ['Tepsi', 'Servis arabası', 'Masa', 'Koltuk'], correct: 1 },
      { question: '"First aid kit" ne demek?', options: ['Yemek kutusu', 'Takım çantası', 'İlk yardım çantası', 'Seyahat çantası'], correct: 2 },
      { question: '"Oxygen mask" ne demek?', options: ['Duman maskesi', 'Yüz maskesi', 'Oksijen maskesi', 'Göz maskesi'], correct: 2 },
      { question: '"Blanket" ne demek?', options: ['Yastık', 'Örtü', 'Battaniye', 'Çarşaf'], correct: 2 },
    ]
  },

  // ÜNİTE 11: Hoşgeldiniz Anonsu
  '11-1': {
    type: 'flashcard',
    title: 'Anons Metni (İngilizce)',
    cards: [
      { front: 'Ladies and gentlemen', back: 'Bayanlar ve baylar' },
      { front: 'Welcome aboard', back: 'Uçağımıza hoş geldiniz' },
      { front: 'Flight TK 123', back: 'TK 123 sefer sayılı uçuş' },
      { front: 'Destination', back: 'Varış noktası' },
      { front: 'Flying time', back: 'Uçuş süresi' },
      { front: 'Cruising altitude', back: 'Seyrüsefer irtifası' },
      { front: 'On behalf of the captain', back: 'Kaptan adına' },
      { front: 'We wish you a pleasant flight', back: 'Keyifli bir uçuş dileriz' },
      { front: 'Cabin crew', back: 'Kabin ekibi' },
      { front: 'Please pay attention', back: 'Lütfen dikkat edin' },
    ]
  },
  '11-2': {
    type: 'flashcard',
    title: 'Anons Metni (Türkçe)',
    cards: [
      { front: 'Uçağımıza hoş geldiniz', back: 'Welcome aboard' },
      { front: 'İstanbul-Londra seferine hoş geldiniz', back: 'Welcome to the Istanbul-London flight' },
      { front: 'Uçuş süremiz yaklaşık 4 saattir', back: 'Our flight time is approximately 4 hours' },
      { front: 'Kaptanlarımız', back: 'Our captains' },
      { front: 'Güvenlik demonstrasyonu', back: 'Safety demonstration' },
      { front: 'Lütfen dikkatle izleyiniz', back: 'Please watch carefully' },
      { front: 'Güvenliğiniz için', back: 'For your safety' },
      { front: 'Keyifli bir uçuş dileriz', back: 'We wish you a pleasant flight' },
    ]
  },
  '11-3': {
    type: 'voice',
    title: 'Telaffuz Pratiği',
    phrases: [
      { text: 'Ladies and gentlemen, welcome aboard.', translation: 'Bayanlar ve baylar, uçağımıza hoş geldiniz.' },
      { text: 'This is flight TK 1234 to London.', translation: 'Bu TK 1234 sefer sayılı Londra uçuşudur.' },
      { text: 'Our flight time today is approximately 4 hours.', translation: 'Bugünkü uçuş süremiz yaklaşık 4 saattir.' },
      { text: 'We will be cruising at an altitude of 35,000 feet.', translation: '35.000 fit irtifada seyrüsefer yapacağız.' },
      { text: 'On behalf of Captain Smith and the entire crew...', translation: 'Kaptan Smith ve tüm ekip adına...' },
      { text: 'We wish you a pleasant flight.', translation: 'Keyifli bir uçuş dileriz.' },
    ]
  },
  '11-4': {
    type: 'voice',
    title: 'Anons Okuma',
    phrases: [
      { text: 'Good morning ladies and gentlemen. Captain Johnson and the flight crew welcome you aboard Turkish Airlines flight 456 with service to New York.', translation: 'Günaydın bayanlar ve baylar. Kaptan Johnson ve uçuş ekibi, New York seferli Türk Hava Yolları 456 uçuşuna hoş geldiniz.' },
      { text: 'Our flight time will be approximately 11 hours and 30 minutes.', translation: 'Uçuş süremiz yaklaşık 11 saat 30 dakika olacaktır.' },
      { text: 'We will be flying at an altitude of 38,000 feet.', translation: '38.000 fit yükseklikte uçacağız.' },
      { text: 'Please direct your attention to the cabin crew for the safety demonstration.', translation: 'Güvenlik gösterimi için lütfen kabin ekibine dikkat edin.' },
    ]
  },
  '11-5': {
    type: 'exam',
    title: 'Anons Değerlendirme',
    description: 'Hoşgeldiniz anonsu yapma pratiği',
    totalQuestions: 5,
    passingScore: 80
  },

  // ÜNİTE 12: Güvenlik Demonstrasyonu
  '12-1': {
    type: 'flashcard',
    title: 'Emniyet Kemeri',
    cards: [
      { front: 'Fasten your seat belt', back: 'Emniyet kemerinizi bağlayın' },
      { front: 'Unfasten your seat belt', back: 'Emniyet kemerinizi çıkarın' },
      { front: 'Insert the metal end into the buckle', back: 'Metal ucu tokaya takın' },
      { front: 'Pull the strap to tighten', back: 'Sıkmak için kayışı çekin' },
      { front: 'Lift the buckle to release', back: 'Açmak için tokayı kaldırın' },
      { front: 'Keep your seat belt fastened', back: 'Kemerinizi bağlı tutun' },
      { front: 'The seat belt sign is on', back: 'Kemer ışığı yanık' },
      { front: 'Low and tight across your hips', back: 'Kalçalarınızın üzerinde alçak ve sıkı' },
    ]
  },
  '12-2': {
    type: 'flashcard',
    title: 'Oksijen Maskesi',
    cards: [
      { front: 'Oxygen mask', back: 'Oksijen maskesi' },
      { front: 'In case of emergency', back: 'Acil durumda' },
      { front: 'Masks will drop automatically', back: 'Maskeler otomatik düşer' },
      { front: 'Pull the mask towards you', back: 'Maskeyi kendinize doğru çekin' },
      { front: 'Place it over your nose and mouth', back: 'Burnunuzu ve ağzınızı kapatacak şekilde yerleştirin' },
      { front: 'Breathe normally', back: 'Normal nefes alın' },
      { front: 'Secure your own mask first', back: 'Önce kendi maskenizi takın' },
      { front: 'Then assist others', back: 'Sonra başkalarına yardım edin' },
    ]
  },
  '12-3': {
    type: 'flashcard',
    title: 'Can Yeleği',
    cards: [
      { front: 'Life jacket / Life vest', back: 'Can yeleği' },
      { front: 'Located under your seat', back: 'Koltuğunuzun altında' },
      { front: 'Place it over your head', back: 'Başınızdan geçirin' },
      { front: 'Fasten the straps', back: 'Kayışları bağlayın' },
      { front: 'Pull to inflate', back: 'Şişirmek için çekin' },
      { front: 'Inflate only outside the aircraft', back: 'Sadece uçak dışında şişirin' },
      { front: 'Light and whistle', back: 'Işık ve düdük' },
      { front: 'For attracting attention', back: 'Dikkat çekmek için' },
    ]
  },
  '12-4': {
    type: 'voice',
    title: 'Demo Anlatımı',
    phrases: [
      { text: 'To fasten your seat belt, insert the metal fitting into the buckle.', translation: 'Emniyet kemerinizi bağlamak için metal parçayı tokaya takın.' },
      { text: 'Pull the strap to tighten it across your hips.', translation: 'Kalçalarınızda sıkmak için kayışı çekin.' },
      { text: 'To unfasten, lift the buckle.', translation: 'Açmak için tokayı kaldırın.' },
      { text: 'Your life jacket is located under your seat.', translation: 'Can yeleğiniz koltuğunuzun altındadır.' },
      { text: 'Oxygen masks will drop automatically in case of decompression.', translation: 'Basınç kaybında oksijen maskeleri otomatik düşer.' },
      { text: 'Please watch the safety video now.', translation: 'Şimdi lütfen güvenlik videosunu izleyin.' },
    ]
  },
  '12-5': {
    type: 'quiz',
    title: 'Güvenlik Quiz',
    questions: [
      { question: 'Can yeleği nerede bulunur?', options: ['Üst bagaj gözünde', 'Koltuk altında', 'Tuvalette', 'Mutfakta'], correct: 1 },
      { question: 'Oksijen maskesini önce kim takmalı?', options: ['Çocuklar', 'Yaşlılar', 'Kendiniz', 'Yolcular'], correct: 2 },
      { question: 'Can yeleği ne zaman şişirilmeli?', options: ['Hemen', 'Koltukta', 'Uçak dışında', 'Hiçbir zaman'], correct: 2 },
      { question: '"Fasten your seat belt" ne demek?', options: ['Kemeri çıkar', 'Kemeri bağla', 'Kemeri gevset', 'Kemeri at'], correct: 1 },
      { question: 'Can yeleğindeki düdük ne için?', options: ['Eğlence', 'Sinyal', 'Dikkat çekme', 'Test'], correct: 2 },
      { question: 'Emniyet kemeri nerede olmalı?', options: ['Göğsün üzerinde', 'Kalçaların üzerinde', 'Dizlerde', 'Omuzda'], correct: 1 },
    ]
  },

  // ÜNİTE 13: Kalkış Öncesi Anonslar
  '13-1': {
    type: 'voice',
    title: 'Kemer Anonsu',
    phrases: [
      { text: 'Ladies and gentlemen, the captain has turned on the seat belt sign.', translation: 'Bayanlar ve baylar, kaptan emniyet kemeri ışığını yaktı.' },
      { text: 'Please return to your seats and fasten your seat belts.', translation: 'Lütfen yerinize dönün ve kemerlerinizi bağlayın.' },
      { text: 'Keep your seat belt fastened while seated.', translation: 'Otururken kemerinizi bağlı tutun.' },
      { text: 'The seat belt sign has been switched off.', translation: 'Kemer ışığı söndürüldü.' },
    ]
  },
  '13-2': {
    type: 'voice',
    title: 'Elektronik Cihaz Anonsu',
    phrases: [
      { text: 'Please turn off all electronic devices.', translation: 'Lütfen tüm elektronik cihazları kapatın.' },
      { text: 'Switch your phone to airplane mode.', translation: 'Telefonunuzu uçak moduna alın.' },
      { text: 'Laptops must be stowed for takeoff and landing.', translation: 'Kalkış ve iniş için laptoplar kaldırılmalıdır.' },
      { text: 'You may now use approved electronic devices.', translation: 'Onaylanmış elektronik cihazları kullanabilirsiniz.' },
    ]
  },
  '13-3': {
    type: 'voice',
    title: 'Koltuk Pozisyonu Anonsu',
    phrases: [
      { text: 'Please return your seat to the upright position.', translation: 'Lütfen koltuğunuzu dik konuma getirin.' },
      { text: 'Fold away your tray table.', translation: 'Masanızı kapatın.' },
      { text: 'Open your window shade.', translation: 'Pencere perdelerinizi açın.' },
      { text: 'Stow your carry-on bags under the seat in front of you.', translation: 'El bagaşınızı önünüzdeki koltuğun altına yerleştirin.' },
    ]
  },
  '13-4': {
    type: 'voice',
    title: 'Kapı Kapama Anonsu',
    phrases: [
      { text: 'Cabin crew, prepare for departure.', translation: 'Kabin ekibi, kalkışa hazırlanın.' },
      { text: 'Doors to automatic and cross-check.', translation: 'Kapıları otomatiğe alın ve çapraz kontrol yapın.' },
      { text: 'All doors are closed.', translation: 'Tüm kapılar kapandı.' },
      { text: 'Cabin crew, take your positions for takeoff.', translation: 'Kabin ekibi, kalkış için yerlerinizi alın.' },
    ]
  },
  '13-5': {
    type: 'quiz',
    title: 'Kalkış Anonsu Quiz',
    questions: [
      { question: '"Airplane mode" ne demek?', options: ['Uçak modu', 'Uçuş modu', 'Kapalı mod', 'Sessiz mod'], correct: 0 },
      { question: '"Return your seat to the upright position" ne demek?', options: ['Yatay konuma', 'Dik konuma getirin', 'Kaldırın', 'Yaslanın'], correct: 1 },
      { question: '"Cross-check" ne demek?', options: ['Çapraz kontrol', 'Kontrol et', 'İşaretle', 'Kapat'], correct: 0 },
      { question: 'Kalkışta laptop nerede olmalı?', options: ['Kucakta', 'Masada', 'Kaldırılmış/saklı', 'Koltuktaki cepde'], correct: 2 },
      { question: 'Pencere perdeleri kalkışta nasıl olmalı?', options: ['Kapalı', 'Açık', 'Yarı açık', 'Farketmez'], correct: 1 },
    ]
  },

  // ÜNİTE 14: Servis Diyalogları
  '14-1': {
    type: 'roleplay',
    title: 'İçecek Servisi',
    dialogue: [
      { speaker: 'A', text: 'Good afternoon. Would you like something to drink?', translation: 'İyi günler. İçecek bir şey ister misiniz?' },
      { speaker: 'B', text: 'Yes, what do you have?', translation: 'Evet, neler var?' },
      { speaker: 'A', text: 'We have water, juice, soft drinks, tea, and coffee.', translation: 'Su, meyve suyu, meşrubat, çay ve kahve var.' },
      { speaker: 'B', text: 'I\'ll have coffee, please.', translation: 'Kahve lütfen.' },
      { speaker: 'A', text: 'With milk or sugar?', translation: 'Süt veya şeker ister misiniz?' },
      { speaker: 'B', text: 'Just milk, please.', translation: 'Sadece süt, lütfen.' },
      { speaker: 'A', text: 'Here you are. Enjoy.', translation: 'Buyrun. Afiyet olsun.' },
      { speaker: 'B', text: 'Thank you very much.', translation: 'Çok teşekkürler.' },
    ]
  },
  '14-2': {
    type: 'roleplay',
    title: 'Yemek Servisi',
    dialogue: [
      { speaker: 'A', text: 'Good evening. For dinner tonight we have chicken or fish.', translation: 'İyi akşamlar. Bu akşamki yemekte tavuk veya balık var.' },
      { speaker: 'B', text: 'What kind of fish is it?', translation: 'Ne tür balık?' },
      { speaker: 'A', text: 'It\'s grilled salmon with vegetables.', translation: 'Sebzeli ızgara somon.' },
      { speaker: 'B', text: 'I\'ll have the salmon, please.', translation: 'Somon alayım lütfen.' },
      { speaker: 'A', text: 'Would you like bread?', translation: 'Ekmek ister misiniz?' },
      { speaker: 'B', text: 'Yes, please.', translation: 'Evet, lütfen.' },
      { speaker: 'A', text: 'Enjoy your meal.', translation: 'Afiyet olsun.' },
      { speaker: 'B', text: 'Thank you.', translation: 'Teşekkürler.' },
    ]
  },
  '14-3': {
    type: 'roleplay',
    title: 'Özel İstekler',
    dialogue: [
      { speaker: 'A', text: 'May I help you?', translation: 'Yardımcı olabilir miyim?' },
      { speaker: 'B', text: 'Yes, I ordered a vegetarian meal.', translation: 'Evet, vejetaryen yemek sipariş etmiştim.' },
      { speaker: 'A', text: 'Let me check. Yes, I have it here. Here you are.', translation: 'Kontrol edeyim. Evet, burada. Buyrun.' },
      { speaker: 'B', text: 'Also, could I have an extra blanket?', translation: 'Ayrıca, fazladan bir battaniye alabilir miyim?' },
      { speaker: 'A', text: 'Of course. I\'ll bring it right away.', translation: 'Tabii ki. Hemen getiriyorum.' },
      { speaker: 'B', text: 'And some hot water for my tea?', translation: 'Ve çayım için biraz sıcak su?' },
      { speaker: 'A', text: 'Certainly. Anything else?', translation: 'Elbette. Başka bir şey?' },
      { speaker: 'B', text: 'No, that\'s all. Thank you.', translation: 'Hayır, bu kadar. Teşekkürler.' },
    ]
  },
  '14-4': {
    type: 'roleplay',
    title: 'Duty Free Satış',
    dialogue: [
      { speaker: 'A', text: 'Would you like to see our duty-free catalog?', translation: 'Duty-free katalogunu görmek ister misiniz?' },
      { speaker: 'B', text: 'Yes, please. I\'m looking for perfume.', translation: 'Evet, lütfen. Parfüm arıyorum.' },
      { speaker: 'A', text: 'We have a nice selection on page 12.', translation: 'Sayfa 12\'de güzel bir seçim var.' },
      { speaker: 'B', text: 'How much is this one?', translation: 'Bu ne kadar?' },
      { speaker: 'A', text: 'It\'s 65 euros or 75 dollars.', translation: '65 euro veya 75 dolar.' },
      { speaker: 'B', text: 'I\'ll take it. Can I pay by card?', translation: 'Bunu alıyorum. Kartla ödeyebilir miyim?' },
      { speaker: 'A', text: 'Yes, we accept all major credit cards.', translation: 'Evet, tüm büyük kredi kartlarını kabul ediyoruz.' },
      { speaker: 'B', text: 'Great, here\'s my card.', translation: 'Harika, buyrun kartım.' },
    ]
  },
  '14-5': {
    type: 'quiz',
    title: 'Servis Quiz',
    questions: [
      { question: '"Enjoy your meal" ne demek?', options: ['Yemeği bitir', 'Afiyet olsun', 'Yemek bitti', 'Daha yemek var'], correct: 1 },
      { question: '"May I help you?" ne demek?', options: ['Bana yardım et', 'Yardım edebilir miyim?', 'Yardıma ihtiyacım var', 'Yardım geliyor'], correct: 1 },
      { question: '"Duty-free" ne demek?', options: ['Görevsiz', 'Ücretsiz', 'Gümrüksüz', 'Vergi dahil'], correct: 2 },
      { question: '"Extra blanket" ne demek?', options: ['Ekstra yastık', 'Fazladan battaniye', 'Büyük örtü', 'Sıcak battaniye'], correct: 1 },
      { question: '"Right away" ne demek?', options: ['Sağa git', 'Hemen', 'Sonra', 'Belki'], correct: 1 },
      { question: '"Would you like...?" ne demek?', options: ['Severmisin?', 'Sever misiniz?', 'İster misiniz?', 'Seviyor musun?'], correct: 2 },
    ]
  },

  // ÜNİTE 15-20 içerik devamı (kısaltılmış)
  '15-1': { type: 'flashcard', title: 'Çocuklu Aileler', cards: [
    { front: 'Baby bassinet', back: 'Bebek besiski' },
    { front: 'Child meal', back: 'Çocuk yemeği' },
    { front: 'Infant', back: 'Bebek (0-2 yaş)' },
    { front: 'Unaccompanied minor', back: 'Refakatsiz çocuk' },
    { front: 'Coloring book', back: 'Boyama kitabı' },
  ]},
  '15-2': { type: 'flashcard', title: 'Yaşlı Yolcular', cards: [
    { front: 'Wheelchair', back: 'Tekerlekli sandalye' },
    { front: 'Assistance', back: 'Yardım' },
    { front: 'Walking aid', back: 'Yürüme desteği' },
    { front: 'Priority boarding', back: 'Öncelikli biniş' },
  ]},
  '15-3': { type: 'flashcard', title: 'Engelli Yolcular', cards: [
    { front: 'Passenger with reduced mobility', back: 'Hareket kısıtlı yolcu' },
    { front: 'Special assistance', back: 'Özel yardım' },
    { front: 'Accessible lavatory', back: 'Engelli tuvaleti' },
    { front: 'Service animal', back: 'Rehber hayvan' },
  ]},
  '15-4': { type: 'roleplay', title: 'Özel Yolcu Diyalogu', dialogue: [
    { speaker: 'A', text: 'Can I help you with your bag?', translation: 'Çantanıza yardımcı olabilir miyim?' },
    { speaker: 'B', text: 'Yes, please. It\'s quite heavy.', translation: 'Evet, lütfen. Oldukça ağır.' },
  ]},
  '15-5': { type: 'quiz', title: 'Özel Yolcu Quiz', questions: [
    { question: '"Wheelchair" ne demek?', options: ['Koltuk', 'Tekerlekli sandalye', 'Yatak', 'Baston'], correct: 1 },
    { question: '"Priority boarding" ne demek?', options: ['Son biniş', 'Öncelikli biniş', 'Normal biniş', 'Gecikmeli biniş'], correct: 1 },
  ]},

  // ÜNİTE 16-20 devam
  '16-1': { type: 'voice', title: 'Türbülans Anonsu', phrases: [
    { text: 'We are experiencing some turbulence.', translation: 'Biraz türbülans yaşıyoruz.' },
    { text: 'Please return to your seat and fasten your seat belt.', translation: 'Lütfen yerinize dönün ve kemerinizi bağlayın.' },
  ]},
  '16-2': { type: 'voice', title: 'Kemer Uyarısı', phrases: [
    { text: 'The captain has turned on the seat belt sign.', translation: 'Kaptan kemer işaretini yaktı.' },
    { text: 'Please remain seated.', translation: 'Lütfen oturur vaziyette kalın.' },
  ]},
  '16-3': { type: 'roleplay', title: 'Yolcu Sakinleştirme', dialogue: [
    { speaker: 'A', text: 'Don\'t worry, turbulence is normal.', translation: 'Merak etmeyin, türbülans normaldir.' },
    { speaker: 'B', text: 'Is everything okay?', translation: 'Her şey yolunda mı?' },
    { speaker: 'A', text: 'Yes, we\'ll be through it shortly.', translation: 'Evet, kısa sürede geçecek.' },
  ]},
  '16-4': { type: 'flashcard', title: 'Acil Durum Hazırlığı', cards: [
    { front: 'Brace position', back: 'Koruma pozisyonu' },
    { front: 'Emergency landing', back: 'Acil iniş' },
    { front: 'Evacuation', back: 'Tahliye' },
  ]},
  '16-5': { type: 'quiz', title: 'Türbülans Quiz', questions: [
    { question: '"Turbulence" ne demek?', options: ['Motor arızası', 'Hava çalkantısı/türbülans', 'Yangın', 'Gecikme'], correct: 1 },
  ]},

  '17-1': { type: 'flashcard', title: 'Tahliye Komutları', cards: [
    { front: 'Evacuate!', back: 'Tahliye!' },
    { front: 'This way!', back: 'Bu taraftan!' },
    { front: 'Jump!', back: 'Atlayın!' },
    { front: 'Leave everything!', back: 'Her şeyi bırakın!' },
    { front: 'Come this way!', back: 'Buraya gelin!' },
    { front: 'Brace! Brace!', back: 'Koruma pozisyonu! Koruma pozisyonu!' },
  ]},
  '17-2': { type: 'voice', title: 'Tahliye Anonsu', phrases: [
    { text: 'This is an emergency. Evacuate immediately!', translation: 'Bu bir acil durumdur. Derhal tahliye!' },
    { text: 'Leave all personal belongings.', translation: 'Tüm kişisel eşyalarınızı bırakın.' },
  ]},
  '17-3': { type: 'flashcard', title: 'Yangın Prosedürü', cards: [
    { front: 'Fire!', back: 'Yangın!' },
    { front: 'Fire extinguisher', back: 'Yangın söndürücü' },
    { front: 'Smoke', back: 'Duman' },
    { front: 'Stay low', back: 'Alçakta kalın' },
  ]},
  '17-4': { type: 'flashcard', title: 'Su İnişi Prosedürü', cards: [
    { front: 'Ditching', back: 'Suya iniş' },
    { front: 'Life raft', back: 'Can salları' },
    { front: 'Inflate your life vest outside', back: 'Can yeleğinizi dışarıda şişirin' },
  ]},
  '17-5': { type: 'quiz', title: 'Acil Durum Quiz', questions: [
    { question: '"Evacuate" ne demek?', options: ['Oturun', 'Tahliye edin', 'Bekleyin', 'Yatın'], correct: 1 },
    { question: '"Brace position" ne demek?', options: ['Ayakta pozisyon', 'Koruma pozisyonu', 'Oturma pozisyonu', 'Yürüme pozisyonu'], correct: 1 },
  ]},

  '18-1': { type: 'voice', title: 'İniş Hazırlık Anonsu', phrases: [
    { text: 'We will be landing in approximately 30 minutes.', translation: 'Yaklaşık 30 dakika içinde iniyoruz.' },
    { text: 'Please return your seat to the upright position.', translation: 'Lütfen koltuğunuzu dik konuma getirin.' },
  ]},
  '18-2': { type: 'voice', title: 'İniş Anonsu', phrases: [
    { text: 'Ladies and gentlemen, welcome to Istanbul.', translation: 'Bayanlar ve baylar, İstanbul\'a hoş geldiniz.' },
    { text: 'The local time is 3:45 PM.', translation: 'Yerel saat 15:45.' },
  ]},
  '18-3': { type: 'flashcard', title: 'Bağlantı Bilgisi', cards: [
    { front: 'Connecting flight', back: 'Aktar malı uçuş' },
    { front: 'Transit', back: 'Transit' },
    { front: 'Gate', back: 'Kapı' },
    { front: 'Transfer desk', back: 'Aktarma masası' },
  ]},
  '18-4': { type: 'voice', title: 'Veda Anonsu', phrases: [
    { text: 'Thank you for flying with us today.', translation: 'Bugün bizimle uçtuğunuz için teşekkürler.' },
    { text: 'We hope to see you again soon.', translation: 'Yakında tekrar görüşmek dileğiyle.' },
  ]},
  '18-5': { type: 'quiz', title: 'İniş Quiz', questions: [
    { question: '"Connecting flight" ne demek?', options: ['Direkt uçuş', 'Aktarmalı uçuş', 'İptal uçuş', 'Gecikmeli uçuş'], correct: 1 },
  ]},

  '19-1': { type: 'flashcard', title: 'Dinleme & Empati', cards: [
    { front: 'I understand your frustration.', back: 'Hayal kırıklığınızı anlıyorum.' },
    { front: 'I apologize for the inconvenience.', translation: 'Verdiğimiz rahatsızlık için özür dilerim.' },
  ]},
  '19-2': { type: 'flashcard', title: 'Özür Cümleleri', cards: [
    { front: 'I\'m terribly sorry.', back: 'Çok özür dilerim.' },
    { front: 'Please accept our apologies.', back: 'Lütfen özürlerimizi kabul edin.' },
  ]},
  '19-3': { type: 'roleplay', title: 'Çözüm Önerme', dialogue: [
    { speaker: 'A', text: 'I understand. Let me see what I can do.', translation: 'Anlıyorum. Ne yapabilirim bakıyorum.' },
    { speaker: 'B', text: 'Thank you, I appreciate it.', translation: 'Teşekkürler, minnettarım.' },
  ]},
  '19-4': { type: 'roleplay', title: 'Zor Yolcu Senaryosu', dialogue: [
    { speaker: 'A', text: 'Sir/Madam, I understand you\'re upset. How can I help?', translation: 'Beyefendi/Hanımefendi, üzgün olduğunuzu anlıyorum. Nasıl yardımcı olabilirim?' },
    { speaker: 'B', text: 'My meal is cold!', translation: 'Yemeğim soğuk!' },
    { speaker: 'A', text: 'I\'m sorry about that. Let me get you a fresh one.', translation: 'Bunun için özür dilerim. Size yeni bir tane getireyim.' },
  ]},
  '19-5': { type: 'quiz', title: 'Şikayet Quiz', questions: [
    { question: '"I apologize" ne demek?', options: ['Özür dilerim', 'Teşekkürler', 'Memnunum', 'Hoşça kal'], correct: 0 },
  ]},

  '20-1': { type: 'flashcard', title: 'Terminoloji Tekrar', cards: [
    { front: 'Review all cabin crew terminology', back: 'Tüm kabin memurluğu terminolojisini tekrarlayın' },
  ]},
  '20-2': { type: 'voice', title: 'Anons Pratiği', phrases: [
    { text: 'Practice all announcements learned.', translation: 'Öğrenilen tüm anonsları pratik yapın.' },
  ]},
  '20-3': { type: 'roleplay', title: 'Senaryo Testi', dialogue: [
    { speaker: 'A', text: 'Complete role-play scenarios.', translation: 'Rol yapma senaryolarını tamamlayın.' },
  ]},
  '20-4': { type: 'quiz', title: 'Yazılı Test', questions: [
    { question: 'Final written test covering all topics.', options: ['Option A', 'Option B', 'Option C', 'Option D'], correct: 0 },
  ]},
  '20-5': { type: 'exam', title: 'BÖLÜM 2 FİNAL', description: 'Kabin Memurluğu bölümünün final sınavı', totalQuestions: 30, passingScore: 75 }
};

export default CABIN_CREW_CONTENTS;
